import { TypeaheadOption } from '@msaf/core-react'
import { SearchResultRow } from '../components/aoraki/generic-search-common/src'
import { WheelEvent, FocusEvent } from 'react'

/**
 * For use to provide unique IDs to new repeated elements that can't use "id" as a key
 */
export function getRandomID(): string {
  return `temp_${Math.floor(Math.random() * 1e10)}`
}

/**
 * Checks if the entered email ends with `govt.nz`
 * This is just a client side check to warn the user in
 * @param email Enter email
 */
export function isValidCouncilEmail(email: string) {
  return /\.govt\.nz$/.test(email.trim().toLowerCase())
}

/**
 * Loose check to see if the given value looks like an email address
 * and doesn't have spaces in it
 */
export function maybeAnEmailAddress(email: string) {
  return email && email.trim().match(/\S+@\S+\.\S+/)
}

/**
 * Attempts to extract locality from address results
 * @param addressLine2 Address lookup result addressline2
 * @param addressLine3 Address lookup result addressline3
 * @returns String for locality
 */
export const getLocalityFromAddressLine = (addressLine2: string | undefined, addressLine3: string) => {
  // No address line 2 - use addressLine3
  if (!addressLine2) {
    return addressLine3
  }

  // If addressLine 2 doesn't contain , or # it will be a suburb
  if (!addressLine2.includes(', ') && !addressLine2.includes('#')) {
    return addressLine2
  }

  // Address line 2 possibly has locality / suburb after ','
  const addressLineSections = addressLine2.split(', ')
  if (addressLineSections.length > 1) {
    return addressLine2.split(', ')[1]
  }

  // Fall through return addressLine3 and user can alter in UI
  return addressLine3
}

/**
 * Returns the suggestions in the required display format
 * @param suggestions List of suggestions returned by the API
 * @returns
 */
export function getQuickSearchDisplayOptions(suggestions: Array<SearchResultRow>) {
  const options: Array<TypeaheadOption> = suggestions.map(({ wellId, councilWellNo, wellName }: SearchResultRow) => ({
    label: `${councilWellNo} - ${wellName}`,
    value: `${wellId}`,
  }))
  return options
}

/**
 * Scrolls to the top of the form page
 */
export function triggerScrollToTop(scrollTarget: string) {
  document.querySelector(scrollTarget)?.scroll({ top: 0, left: 0, behavior: 'smooth' })
}

/**
 * Prevents field values being changed when the field is still in focus and the page is scrolled
 * https://medium.com/modernnerd-code/how-to-disabled-scrolling-on-html-number-input-in-react-6548841166fb

 */
export const preventChangeOnScroll = (e: WheelEvent<HTMLInputElement> & FocusEvent<HTMLInputElement>) => {
  // Prevent the input value change only if the element is focused.
  if (e.target === document.activeElement) {
    e.target.blur()
  }

  // Prevent the page/container scrolling
  e.stopPropagation()
}
